import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { requestNotificationPermission, registerAndSubscribe } from '../utils/pushNotifications';
import buildInfo from '../buildInfo.json';
import { formatDateTime } from '../utils/formatDate';

const LogInForm = ({ handleLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        if (!username || !password) {
            setErrorMessage('Por favor ingresa usuario y contraseña.');
            return;
        }

        // Fired synchronously inside this tap — iOS only shows the native
        // permission dialog while the gesture is still active, so this can't
        // wait for the login request to resolve first. The returned promise
        // is awaited below (after login), not discarded — see the comment
        // there for why that matters.
        const permissionPromise = requestNotificationPermission();

        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new Error('Respuesta del servidor no es JSON.');
            }

            const data = await response.json();

            if (response.ok && data.user) {
                console.log('✅ Usuario autenticado:', data.user);

                // Store only what you need
                localStorage.setItem('userType', data.user.role);
                localStorage.setItem('userName', data.user.username);
                localStorage.setItem('token', data.token);

                // A fast login response can resolve before the user has
                // tapped Allow/Don't Allow on the still-visible permission
                // dialog — wait for their actual decision before checking
                // Notification.permission inside registerAndSubscribe(),
                // instead of racing it and silently skipping subscription.
                await permissionPromise;
                registerAndSubscribe();

                const redirectTo = handleLogin(data.user); // App.js logic handles this
                navigate(redirectTo);
            } else {
                console.error('❌ Login failed:', data);
                setErrorMessage(data.message || 'Credenciales inválidas.');
            }
        } catch (err) {
            console.error('❌ Error de conexión:', err);
            setErrorMessage('No se pudo conectar al servidor.');
        }
    };

    return (
        <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--mm-bg)' }}>
            <div className="card shadow-lg p-4" style={{ maxWidth: '420px', width: '100%', borderRadius: '16px' }}>
                <div className="text-center mb-4">
                    <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: '2rem', color: 'var(--mm-cyan)', fontWeight: 700, letterSpacing: '-0.01em' }}>
                        MANIFOLD MANAGER
                    </div>
                    <h4 className="mt-2 mb-0" style={{ color: 'var(--mm-muted)', fontSize: '1.05rem', fontWeight: 500 }}>Iniciar sesión</h4>
                </div>

                {errorMessage && (
                    <div className="alert alert-danger text-center">{errorMessage}</div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3">
                        <label htmlFor="username" className="form-label text-muted">Usuario</label>
                        <input
                            type="text"
                            className="form-control"
                            id="username"
                            placeholder="Ingresa tu usuario"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>

                    <div className="form-group mb-4">
                        <label htmlFor="password" className="form-label text-muted">Contraseña</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            placeholder="Ingresa tu contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn w-100"
                        style={{
                            background: 'linear-gradient(to right, var(--mm-cyan), #0E8C86)',
                            color: '#06222B',
                            fontWeight: 'bold',
                            borderRadius: '10px'
                        }}
                    >
                        Ingresar
                    </button>
                </form>

                <div className="text-center mt-3">
                    <small className="text-muted">
                        v{buildInfo.version} · {formatDateTime(buildInfo.buildTime)}
                    </small>
                </div>
            </div>
        </div>
    );
};

export default LogInForm;
